import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import api from "@/lib/api";

export default function AuthCallback() {
  const hasProcessed = useRef(false);
  const navigate = useNavigate();
  const { setUser } = useAuth();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processSession = async () => {
      const hash = window.location.hash;
      const sessionId = hash.split("session_id=")[1]?.split("&")[0];

      if (!sessionId) {
        navigate("/auth", { replace: true });
        return;
      }

      try {
        const res = await api.get(`/auth/session?session_id=${sessionId}`);
        if (res.data.token) {
          localStorage.setItem("bb_token", res.data.token);
        }
        setUser(res.data.user);

        // Clear hash and navigate
        window.history.replaceState(null, "", window.location.pathname);

        if (res.data.user.onboarding_complete) {
          navigate("/dashboard", { replace: true, state: { user: res.data.user } });
        } else {
          navigate("/onboarding", { replace: true, state: { user: res.data.user } });
        }
      } catch (err) {
        console.error("Auth callback error:", err);
        navigate("/auth", { replace: true });
      }
    };

    processSession();
  }, [navigate, setUser]);

  return (
    <div className="h-screen flex items-center justify-center bg-black" data-testid="auth-callback">
      <div className="w-8 h-8 border-2 border-[#00FF88] border-t-transparent rounded-full animate-spin" />
    </div>
  );
}
